import { merge, sortBy } from 'lodash'
import { AUTOMATED_ALERTS } from '../../utils/constants'

const initialState = {
	households: null,
	selected: null,
	loading: false,
	selectedLoading: false,
	error: null,
	membershipTypes: [],
	bankLoading: false,
	lineItemFilters: {
		client_transactions: [
			{ value: 'bundle', label: 'Bundle Purchases' },
			{ value: 'used_credits', label: 'Used Credits' },
			{ value: 'expired_credits', label: 'Expired Credits' },
			{ value: 'credit_deposits', label: 'Credit Deposits' },
			{ value: 'other', label: 'Other Transactions' }
		],
		gift_cards: {
			value: 'gift_cards',
			label: 'Gift Cards'
		},
		promotions: {
			value: 'promotions',
			label: 'Promotions'
		}
	},
	selectedLineItemFilters: {
		client_transactions: [],
		gift_cards: false,
		promotions: false
	}
}

const households = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_SELECTED_LINE_ITEM_FILTERS':
			return { ...state, selectedLineItemFilters: action.payload }
		case 'ADD_BANK': {
			return {
				...state,
				bankLoading: true
			}
		}
		case 'ADD_BANK_FAIL': {
			return {
				...state,
				bankLoading: false
			}
		}
		case 'ADD_BANK_SUCCESS': {
			return {
				...state,
				bankLoading: false,
				selected: {
					...state.selected,
					addon_bank: action.payload
				}
			}
		}
		case 'ADD_CHARGE_SUCCESS': {
			if (action.payload.amount > 0) return state
			const cred = state.selected.credit || 0

			return {
				...state,
				selected: {
					...state.selected,
					credit: cred + Math.abs(action.payload.amount)
				}
			}
		}
		case 'TOGGLE_PET_SELECTED': {
			const index = state.selected.pets.findIndex((pet) => pet._id === action.payload._id)

			const pets = state.selected.pets
			pets[index] = {
				...state.selected.pets[index],
				isSelected: state.selected.pets[index].isSelected ? !state.selected.pets[index].isSelected : true
			}

			return {
				...state,
				selected: {
					...state.selected,
					pets
				}
			}
		}
		case 'UPDATE_MEMBERSHIP': {
			return {
				...state,
				memberLoading: true
			}
		}
		case 'RESET_APP':
			return { ...initialState }
		case 'CLEAR_HOUSEHOLD':
			return { ...state, selected: null, loading: false, error: null }
		case 'CLEAR_HOUSEHOLDS':
			return { ...state, households: null, loading: false, error: null }
		case 'GET_HOUSEHOLDS':
			return { ...state, loading: true }
		case 'GET_HOUSEHOLDS_SUCCESS':
			let households = action.payload

			households = households.map((household) => {
				household.account = household.account
					? household.account
					: household.accounts.length > 0
						? household.accounts.find((account) => account.primary) || household.accounts[0]
						: null

				return household
			})

			households.forEach((household) => {
				household.searchable_pets = household.pets.map((pet) => pet.name).join(' ')
			})

			return {
				...state,
				loading: false,
				households: sortBy(households, 'account.full_name'),
				error: null
			}
		case 'GET_HOUSEHOLDS_FAIL':
			return {
				...state,
				loading: false,
				memberLoading: false,
				error: 'Error while fetching clients.'
			}
		case 'POST_MEMBERSHIP':
			return { ...state, memberLoading: true }
		case 'POST_MEMBERSHIP_FAIL':
			return { ...state, memberLoading: false }
		case 'GET_MEMBERSHIP_TYPES':
			return { ...state, memberLoading: true }
		case 'SET_MEMBERSHIP_TYPES':
			return {
				...state,
				memberLoading: false,
				membershipTypes: action.payload
			}
		case 'GET_MEMBERSHIP_TYPES_FAIL':
			return {
				...state,
				memberLoading: false,
				error: 'Error while fetching membership types'
			}
		case 'SET_SELECTED_HOUSEHOLD':
			const household = action.payload

			if (household) {
				household.pets = household.pets || []
				household.account = household.account
					? household.account
					: household.accounts.length > 0
						? household.accounts.find((account) => account.primary)
						: null
			}

			return {
				...state,
				loading: false,
				selected: household,
				error: null,
				memberLoading: false
			}
		case 'POST_HOUSEHOLD':
			return { ...state, loading: true, error: null }
		case 'POST_HOUSEHOLD_FAIL':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while creating a client.'
			}
		case 'UPDATE_HOUSEHOLD':
			return { ...state, loading: true, error: null }
		case 'UPDATE_FOUNDING': {
			return {
				...state,
				loading: false,
				selected: {
					...state.selected,
					founding_member: action.payload
				}
			}
		}
		case 'UPDATE_MUTE_RENEWAL_ALERT': {
			return {
				...state,
				loading: false,
				selected: {
					...state.selected,
					mute_renewal_alert: action.payload
				}
			}
		}
		case 'ADD_SELECTED_HOUSEHOLD_DAYPASSES': {
			const selected = state.selected
			const { daypasses = [], household_id } = action.payload
			if (selected && selected._id === household_id) {
				let updatedDaypass = state?.selected?.credits?.daypass || []
				updatedDaypass = [...updatedDaypass, ...daypasses]

				return {
					...state,
					selected: {
						...selected,
						credits: { ...selected.credits, daypass: updatedDaypass }
					},
					loading: false,
					error: null
				}
			}
		}
		case 'REMOVE_SELECTED_HOUSEHOLD_DAYPASSES': {
			const selected = state.selected
			const { daypass_ids = [], household_id } = action.payload
			if (selected && selected._id === household_id) {
				let updatedDaypass = state?.selected?.credits?.daypass || []
				updatedDaypass = updatedDaypass.filter((dp) => {
					return !daypass_ids.includes(dp._id)
				})

				return {
					...state,
					selected: {
						...selected,
						credits: { ...selected.credits, daypass: updatedDaypass }
					},
					loading: false,
					error: null
				}
			}
		}
		case 'UPDATE_SELECTED_HOUSEHOLD': {
			const selected = state.selected
			const { updates = {}, household_id } = action.payload
			if (selected && selected._id === household_id) {
				return {
					...state,
					selected: { ...selected, ...updates },
					loading: false,
					error: null
				}
			}
		}
		case 'UPDATE_HOUSEHOLD_SUCCESS': {
			let selected = state.selected
			const household = action.payload

			if (selected && household && selected._id === household._id) {
				if (Array.isArray(household.accounts) && Array.isArray(selected.accounts)) {
					household.accounts = selected.accounts.map((account) => {
						const accountToUpdate = household.accounts.find((a) => a._id === account._id)

						if (accountToUpdate) {
							return accountToUpdate
						}

						return account
					})
				}

				selected = merge(selected, household)

				if (household.transactions) {
					selected.transactions = household.transactions
				}

				if (household.service_line_data) {
					selected.service_line_data = household.service_line_data
				}

				if (household.facility_cards) {
					selected.facility_cards = household.facility_cards
				}

				if (household.facility_card) {
					const next = Array.isArray(selected.facility_cards) ? [...selected.facility_cards] : []
					const index = next.findIndex(
						(entry) => String(entry.facility_id) === String(household.facility_card.facility_id)
					)

					if (index >= 0) next[index] = household.facility_card
					else next.push(household.facility_card)

					selected.facility_cards = next
				}
			}

			return {
				...state,
				selected: { ...selected },
				loading: false,
				error: null
			}
		}
		case 'UPDATE_HOUSEHOLD_FAIL':
			return {
				...state,
				loading: false,
				error:
					action.payload ||
					'An error occured while updating the selected client (UPDATE_HOUSEHOLD_FAIL).'
			}
		case 'CLEAR_HOUSEHOLD_ERROR':
			return { ...state, loading: false, error: null }
		case 'UPDATE_PET':
			return { ...state, loading: true, error: null }
		case 'UPDATE_PET_STAFF_NOTES': {
			const { _id: pet_id, staff_notes, staff_notes_counts } = action.payload || {}
			if (!pet_id) {
				return
			}
			const selected = state.selected
			const selectedPets = selected ? selected.pets : []

			const updatedPets = selectedPets.map((pet) => {
				if (pet._id !== pet_id) {
					return pet
				}
				const updatedPet = { ...pet }
				if (staff_notes) {
					updatedPet.staff_notes = staff_notes.map((note) => {
						if (note.type === 'Alert') {
							note.filter_type = AUTOMATED_ALERTS
						} else {
							note.filter_type = note.type
						}
						return note
					})
				}
				if (staff_notes_counts) {
					updatedPet.staff_notes_counts = staff_notes_counts
				}
				return updatedPet
			})

			return {
				...state,
				selected: { ...selected, pets: updatedPets },
				loading: false,
				error: null
			}
		}
		case 'UPDATE_PET_SUCCESS': {
			const pet = action.payload
			const selected = state.selected
			const selectedPets = selected ? selected.pets : []
			const foundPetIndex =
				pet && selectedPets && selectedPets.length
					? selectedPets.findIndex((p) => p._id === pet._id)
					: null

			if (foundPetIndex !== -1) {
				const existingPetRecord = selectedPets[foundPetIndex]
				const updatedPet = merge(existingPetRecord, action.payload)
				if (pet.tags) updatedPet.tags = pet.tags
				if (pet.temporary_service_restrictions)
					updatedPet.temporary_service_restrictions = pet.temporary_service_restrictions
				if (pet.permanent_service_restrictions)
					updatedPet.permanent_service_restrictions = pet.permanent_service_restrictions
				if (pet.spay_neuter_deadline) updatedPet.spay_neuter_deadline = pet.spay_neuter_deadline
				if (pet.intolerances) updatedPet.intolerances = pet.intolerances
				if (pet.food_schedule) updatedPet.food_schedule = pet.food_schedule
				if (pet.facility_food_instructions)
					updatedPet.facility_food_instructions = pet.facility_food_instructions
				if (pet.medications) updatedPet.medications = pet.medications
				if (pet.vaccine_files) updatedPet.vaccine_files = pet.vaccine_files
				if (pet.other_playgroup_types) updatedPet.other_playgroup_types = pet.other_playgroup_types
				if (pet.best_fit_playgroup_type) updatedPet.best_fit_playgroup_type = pet.best_fit_playgroup_type
				if (pet.alt_playgroup_type) updatedPet.alt_playgroup_type = pet.alt_playgroup_type
				if (pet.night_program_restrictions)
					updatedPet.night_program_restrictions = pet.night_program_restrictions
				updatedPet.duration_table = pet.duration_table || null
				updatedPet.grooming_addons = pet.grooming_addons || []
				updatedPet.allowed_grooming_services = pet.allowed_grooming_services || []
				selectedPets[foundPetIndex] = { ...updatedPet }
			}

			return {
				...state,
				selected: { ...selected, pets: [...selectedPets] },
				loading: false,
				error: null
			}
		}
		case 'UPDATE_PET_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'UPDATE_VACCINE':
			return { ...state, loading: true, error: null }
		case 'UPDATE_VACCINE_SUCCESS': {
			const vaccine = action.payload
			const selected = state.selected
			const selectedPets = selected ? selected.pets : null
			const foundPetIndex = selectedPets.findIndex((p) => p._id === vaccine.pet_id)

			if (foundPetIndex !== -1) {
				const pet = selected.pets[foundPetIndex]
				const foundVaccineIndex = pet.vaccines.findIndex((v) => v._id === vaccine._id)

				if (foundVaccineIndex !== -1) {
					const updatedVaccine = merge(pet.vaccines[foundVaccineIndex], vaccine)

					pet.vaccines[foundVaccineIndex] = { ...updatedVaccine }
					selected.pets[foundPetIndex] = { ...pet }
				}
			}

			return {
				...state,
				selected: { ...selected },
				loading: false,
				error: null
			}
		}
		case 'UPDATE_VACCINE_FAIL':
			return { ...state, loading: false, error: action.payload }
		case 'POST_VACCINE':
			return { ...state, loading: true, error: null }
		case 'POST_VACCINE_SUCCESS': {
			const vaccine = action.payload
			const selected = state.selected
			const selectedPets = selected ? selected.pets : null
			const foundPetIndex = selectedPets.findIndex((p) => p._id === vaccine.pet_id)

			if (foundPetIndex !== -1) {
				const pet = selected.pets[foundPetIndex]

				pet.vaccines = [...pet.vaccines, vaccine]

				selected.pets[foundPetIndex] = { ...pet }
			}

			return {
				...state,
				selected: { ...selected },
				loading: false,
				error: null
			}
		}
		case 'POST_VACCINE_FAIL':
			return { ...state, loading: false, error: action.payload }

		case 'ADD_PET':
			return { ...state, loading: true, error: null }
		case 'ADD_PET_SUCCESS': {
			const selected = state.selected
			const pet = action.payload

			if (pet && selected && pet.household_id === selected._id) {
				selected.pets = [...selected.pets, pet]
			}

			return {
				...state,
				loading: false,
				selected: { ...selected },
				error: null
			}
		}
		case 'ADD_PET_FAIL':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while creating a pet.'
			}
		case 'REMOVE_PET':
			return { ...state, loading: true, error: null }
		case 'REMOVE_PET_SUCCESS': {
			const selected = state.selected
			const id = action.payload

			let foundPetIndex

			if (selected && Array.isArray(selected.pets)) {
				foundPetIndex = selected.pets.findIndex((p) => p._id === id)
			}

			if (selected && id && foundPetIndex && foundPetIndex !== -1) {
				const foundPetIdIndex = selected.pet_ids.findIndex((p) => p === id)

				if (foundPetIdIndex !== -1) selected.pet_ids = selected.pet_ids.filter((p) => p !== id)
				selected.pets = selected.pets.filter((p) => p._id !== id)
			}

			return {
				...state,
				selected: { ...selected },
				loading: false,
				error: null
			}
		}
		case 'REMOVE_PET_FAIL':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while removing the selected pet.'
			}
		case 'UPDATE_CREDITS':
			return { ...state, loading: true, error: null }
		case 'UPDATE_CREDITS_SUCCESS': {
			const selected = state.selected
			const { _id, credits } = action.payload

			if (selected && _id && selected._id === _id) {
				for (const credit in selected.credits) {
					if (selected.credits.hasOwnProperty(credit)) {
						if (credits && credits[credit]) {
							selected.credits[credit] = credits[credit]
						}
					}
				}
			}

			return {
				...state,
				selected: { ...selected },
				loading: false,
				error: null
			}
		}
		case 'DELETE_CREDITS_SUCCESS': {
			const selected = state.selected
			const { _id, removedCreditIds } = action.payload

			if (selected && _id && selected._id === _id) {
				if (Array.isArray(removedCreditIds) && removedCreditIds.length) {
					for (const credit in selected.credits) {
						if (selected.credits.hasOwnProperty(credit)) {
							if (selected.credits[credit]) {
								selected.credits[credit] = selected.credits[credit].filter(
									(c) => !removedCreditIds.includes(c._id)
								)
							}
						}
					}
				}
			}

			return {
				...state,
				selected: { ...selected },
				loading: false,
				error: null
			}
		}
		case 'UPDATE_CREDITS_FAIL':
			return {
				...state,
				loading: false,
				error: action.payload || 'An error occured while updating this clients credits.'
			}
		default:
			return state
	}
}

export default households
